var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGreenLines = function SvgGreenLines(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 410,
    height: 212,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#00EA90",
    strokeWidth: 4,
    d: "M408 101.962c0 92.01-.034 189.918-.034 206.506 0 16.588-5.879 38.264-27.756 53.009-21.202 14.291-54.396 14.335-70.952-1.769-16.555-16.104-204.579-200.355-217.03-212.004-12.45-11.648-25.39-37.305-13.565-70.334 11.826-33.03 38.433-38.518 53.806-39.108 15.373-.59 192.753 0 211.674 0 18.921 0 34.294 2.95 45.528 13.566C403.939 65.312 408 78.37 408 101.962Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00EA90",
    strokeWidth: 4,
    d: "M275.81-89.758c0 75.154-.028 155.125-.028 168.674 0 13.549-4.802 31.254-22.671 43.298-17.318 11.672-44.431 11.708-57.953-1.445-13.523-13.154-167.1-163.65-177.269-173.165-10.17-9.514-20.74-30.47-11.08-57.449 9.659-26.978 31.391-31.46 43.948-31.942 12.556-.482 157.44 0 172.895 0 15.454 0 28.01 2.409 37.186 11.08 11.655 11.014 14.972 21.679 14.972 40.95Z"
  })));
};
export default SvgGreenLines;